export const DATE_FORMAT = 'YYYY-MM-DD';
export const HUMAN_DATE = 'ddd MMM Do';
export const DATE_FORMAT_NICE = 'MMM Do YYYY';

export const MILLISECONDS_IN_SECOND = 1000;
export const SECONDS_IN_MINUTE = 60;
export const MILLISECONDS_IN_MINUTE =
  SECONDS_IN_MINUTE * MILLISECONDS_IN_SECOND;
export const MINUTES_IN_HOUR = 60;
export const MILLISECONDS_IN_HOUR = MINUTES_IN_HOUR * MILLISECONDS_IN_MINUTE;
export const HOURS_IN_DAY = 24;
export const MILLISECONDS_IN_DAY = MILLISECONDS_IN_HOUR * HOURS_IN_DAY;
export const DAYS_IN_WEEK = 7;
export const DAYS_IN_YEAR = 365;
export const days: string[] = [
  'Zondag',
  'Maandag',
  'Dinsdag',
  'Woensdag',
  'Donderdag',
  'Vrijdag',
  'Zaterdag',
];

export const parseDate = (date: string): Date => new Date(Date.parse(date));

export const formatDate = (d: Date = new Date()): string => {
  const month = `${d.getMonth() + 1}`;
  const day = `${d.getDate()}`;

  return `${d.getFullYear()}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
};

export const formatDateNice = (d: Date = new Date()): string => {
  const day = d.getDate();
  const ordinal = getOrdinal(day);

  return `${day} ${d.toLocaleDateString('nl-NL', {
    month: 'long',
  })} ${d.getFullYear()}`;
};

export const formatDateNicer = (d: Date = new Date()): string => {
  const day = days[d.getDay()];
  return `${day} ${formatDateNice(d)}`;
};

export const getWeek = (d: Date = new Date()): number => {
  const jan1st = new Date(d.getFullYear(), 0, 1);

  // adjust week start to monday
  if (d.getDay() === 0) {
    d = new Date(d.getTime() - 1 * MILLISECONDS_IN_DAY);
  }

  return (
    Math.floor(
      ((d.getTime() - jan1st.getTime()) / MILLISECONDS_IN_DAY +
        jan1st.getDay()) /
        DAYS_IN_WEEK,
    ) + 1
  );
};

export const getWeekStart = (weekNumber: number): Date => {
  const jan1st = new Date(`${new Date().getFullYear()}-01-01T00:00:00.000Z`);
  const date = new Date(
    jan1st.getTime() +
      (weekNumber - 1) * DAYS_IN_WEEK * MILLISECONDS_IN_DAY -
      (jan1st.getDay() - 1) * MILLISECONDS_IN_DAY,
  );
  date.setHours(0);
  date.setMinutes(0);
  date.setSeconds(0);
  return date;
};

export const getOrdinal = (day: number): string => {
  const mapping = {
    st: [1, 21, 31],
    nd: [2, 22],
    rd: [3, 23],
  };

  return Object.entries(mapping).reduce(
    (acc: string, [key, vals]: [string, number[]]): string => {
      return vals.includes(day) ? key : acc;
    },
    'th',
  );
};
